"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.object.keys.js");
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));
var _HeaderSearch = _interopRequireDefault(require("@/components/HeaderSearch"));
var _Git = _interopRequireDefault(require("@/components/RuoYi/Git"));
var _Doc = _interopRequireDefault(require("@/components/RuoYi/Doc"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _sysOrgnization = require("@/api/tenant/sysOrgnization");
var _dept = require("@/api/system/dept");
var _user = require("@/api/system/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    Screenfull: _Screenfull.default,
    SizeSelect: _SizeSelect.default,
    Search: _HeaderSearch.default,
    RuoYiGit: _Git.default,
    RuoYiDoc: _Doc.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      messageNumber: 0,
      open: false,
      tenantOptions: undefined,
      value: undefined,
      tenantIds: undefined,
      isAdmin: true,
      // 登陆用户所在组织
      tenantIdName: '',
      tenantList: [],
      // 登陆用户绑定的组织
      deptList: [],
      // 登陆用户所在组织
      deptId: '',
      deptName: '',
      // 用户昵称
      nickName: '',
      // 是否显示切换部门选择
      isEnableChangeDept: require('@/settings.js').isEnableChangeDept,
      form: {
        // 登陆用户所在组织
        tenantId: ''
      },
      currentTenantId: ''
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'device'])), {}, {
    setting: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    }
  }),
  created: function created() {
    var _self = this;
    this.freeIsAdmin(function () {
      _self.isAdmin = false;
      _self.initData();
      _self.getTenant();
      // 查询登陆用户绑定组织
      _self.listDept();
      _self.getTenantIds();
    });
  },
  methods: {
    initData: function initData() {
      var dictJson = sessionStorage.getItem('userInfo');
      if (dictJson) {
        var array = JSON.parse(dictJson);
        this.currentTenantId = array.tenantId;
        this.tenantIdName = array.tenantName;
        this.deptId = array.deptId;
        this.deptName = array.deptName;
        this.nickName = array.nickName;
      }
    },
    // 切换部门
    changeDept: function changeDept(value) {
      var _this = this;
      // 修改用户loginuser和前端getInfo用户的dept数据
      // 更新用户表的dept_id
      (0, _dept.changeDept)(value).then(function (resp) {
        if (resp && resp.code === 200) {
          _this.$store.dispatch('GetInfo').then(function () {
            location.reload();
          });
        }
      });
    },
    // 查询登陆用户绑定部门
    // listDept() {
    //   listDept().then((resp) => {
    //     if (resp && resp.code === 200) {
    //       console.log('resp.data',resp.data)
    //       this.deptList = resp.data
    //     }
    //   })
    // },
    // 查询登陆用户绑定部门
    listDept: function listDept() {
      var _this2 = this;
      (0, _dept.getUserDeptList)().then(function (res) {
        if (res && res.code === 200) {
          _this2.deptList = res.data;
        }
      });
    },
    /** 查询组织下拉树结构 */freeIsAdmin: function freeIsAdmin(call) {
      (0, _user.isAdmin)().then(function (response) {
        if (!response.data) {
          if (call) call();
        }
      });
    },
    /** 查询当前用户的所有组织 **/getTenant: function getTenant() {
      var _this3 = this;
      (0, _sysOrgnization.listAllTenantByUser)().then(function (resp) {
        if (resp && resp.code === 200) {
          _this3.tenantList = resp.data;
        }
      });
    },
    /*    getTreeselect() {
          listAllTenantByUser().then(response => {
            this.tenantOptions = response.data;
          });
        },*/
    getTenantIds: function getTenantIds() {
      var _this4 = this;
      (0, _sysOrgnization.tenantIds)().then(function (response) {
        _this4.tenantIds = response.tenantIds;
        _this4.tenantIdName = response.tenantIdName;
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this5.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'btn-custom-cancel',
                type: 'warning'
              }).then(function () {
                _this5.$store.dispatch('LogOut').then(function () {
                  location.href = '/index';
                });
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    switchDept: function switchDept() {
      this.open = true;
    },
    // 取消按钮
    cancel: function cancel() {
      this.open = false;
    },
    /** 切换组织 */submitForm: function submitForm() {
      var _this6 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!_this6.form.tenantId) {
                _context2.n = 2;
                break;
              }
              if (!(_this6.form.tenantId === _this6.currentTenantId)) {
                _context2.n = 1;
                break;
              }
              _this6.open = false;
              return _context2.a(2);
            case 1:
              _this6.$confirm('确定切换并刷新？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'btn-custom-cancel',
                type: 'warning'
              }).then(function () {
                (0, _user.changeToken)(_this6.form.tenantId).then(function (response) {
                  if (response.code === 200) {
                    _this6.$store.dispatch('ChangeToken', response.message).then(function () {
                      location.reload();
                    });
                  }
                });
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};